import React from 'react'
import HeroSection from '../../components/HeroSection'
import DamageImage from '../../images/szkoda.jpg'
import '../../style/ofertacard.css'

import PzuLogo from '../../images/logo/pzu.png'
import WartaLogo from '../../images/logo/warta.png'
import HdiLogo from '../../images/logo/hdi.png'
import InterLogo from '../../images/logo/inter.png'
import UniqaLogo from '../../images/logo/uniqa.png'
import GeneraliLogo from '../../images/logo/generali.webp'

const insuranceCompanies = [
  {
    name: 'PZU',
    logo: PzuLogo,
    url: 'https://www.pzu.pl/szkody-i-roszczenia'
  },
  {
    name: 'Warta',
    logo: WartaLogo,
    url: 'https://www.warta.pl/pomoc-i-obsluga/zgloszenie-szkody/'
  },
  {
    name: 'HDI',
    logo: HdiLogo,
    url: 'https://hdi.pl/pomoc-i-obsluga/zglos-szkode/'
  },
  {
    name: 'Uniqa',
    logo: UniqaLogo,
    url: 'https://www.uniqa.pl/szkody-i-roszczenia/'
  },
  {
    name: 'Inter Polska',
    logo: InterLogo,
    url: 'https://inter-direct.pl/zglos-szkode'
  },
  {
    name: 'Generali',
    logo: GeneraliLogo,
    url: 'https://moje.generali.pl/claimonweb/frontend/#/'
  }
]

const ZglosSzkode = () => {
  return (
    <>
      <HeroSection
        image={DamageImage}
        text="Zgłoś szkodę – szybki kontakt z Twoim ubezpieczycielem"
      />

      <section style={{ maxWidth: '1100px', margin: '2rem auto', padding: '0 1rem' }}>
        <h2 style={{ textAlign: 'center' }}>Zgłoszenie szkody</h2>
        <p style={{ textAlign: 'center' }}>
          Wybierz swojego ubezpieczyciela i przejdź bezpośrednio do formularza zgłoszeniowego.
        </p>

        <div
          className="oferta-buttons"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '2rem',
            marginTop: '2rem'
          }}
        >
          {insuranceCompanies.map(({ name, logo, url }) => (
            <a
              key={name}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="ofertacard-card"
              style={{ textDecoration: 'none' }}
            >
              <div className="ofertacard-button">
                <img
                  src={logo}
                  alt={`${name} logo`}
                  className="ofertacard-icon"
                />
                <div className="ofertacard-label">{name}</div>
                <div className="ofertacard-color-bar" style={{ '--accent-color': '#003366' }}></div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </>
  )
}

export default ZglosSzkode
